import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file index.tsx
 * @author markJia(markjia@tencent.com)
 */
import React from 'react';
import { Close } from '@tencent/adp-icons-react';
import { withViewComponent } from '../../hoc/withViewComponent';

var getStyle = function getStyle(ops) {
  var block = ops.block,
      type = ops.type,
      color = ops.color,
      fill = ops.fill,
      style = ops.style;
  var css = {};

  if (block) {
    css.display = 'block';
  }

  if (color && type === 'color') {
    if (fill) {
      css.backgroundColor = color;
    } else {
      css.borderColor = color;
      css.color = color;
    }
  }

  return _objectSpread(_objectSpread({}, css), style);
};

export var ViewTag = withViewComponent(function ($p, $s, $c, $a) {
  var _$c;

  var elRef = $p.elRef,
      _$p$type = $p.type,
      type = _$p$type === void 0 ? 'default' : _$p$type,
      _$p$size = $p.size,
      size = _$p$size === void 0 ? 'md' : _$p$size,
      color = $p.color,
      closable = $p.closable,
      _$p$fill = $p.fill,
      fill = _$p$fill === void 0 ? false : _$p$fill,
      _$p$block = $p.block,
      block = _$p$block === void 0 ? false : _$p$block,
      onClose = $p.onClose,
      children = $p.children;
  var cls = $c(true, (_$c = {
    size: size
  }, _defineProperty(_$c, type, true), _defineProperty(_$c, "fill", fill), _defineProperty(_$c, "closable", closable), _$c), true);
  var closeNode = closable ? React.createElement("span", {
    className: $c('close'),
    onClick: onClose
  }, React.createElement(Close, {
    size: 10
  })) : null;
  var nextStyle = getStyle({
    style: $s,
    fill: fill,
    color: color,
    type: type,
    block: block
  });
  return React.createElement("span", _objectSpread(_objectSpread({}, $a), {}, {
    style: nextStyle,
    className: cls,
    ref: elRef
  }), React.createElement("span", {
    className: $c('content')
  }, children), closeNode);
}, 'tag', ['elRef', 'type', 'fill', 'block', 'size', 'color', 'closable', 'onClose', 'children']);